export default function SearchBar({ placeholder, onSearch, variant = "default" }){
  const isHeroVariant = variant === "hero";

  const containerClasses = isHeroVariant 
    ? "flex items-center bg-white/10 backdrop-blur-sm border border-white/20 p-3 rounded-2xl shadow-lg" 
    : "flex items-center bg-white p-3 rounded-2xl shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-200";

  const inputClasses = isHeroVariant
    ? "flex-grow px-4 py-3 bg-transparent text-white placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-white/30 rounded-l-2xl text-lg" 
    : "flex-grow px-4 py-3 rounded-l-2xl focus:outline-none focus:ring-2 focus:ring-blue-500/30 text-gray-700 placeholder-gray-400 text-lg";
  
  const buttonClasses = isHeroVariant
    ? "p-3 text-white hover:text-blue-200 transition-colors duration-200" 
    : "p-3 text-gray-500 hover:text-blue-600 transition-colors duration-200";

  return(
    <div className={containerClasses}>
      <input 
        className={inputClasses} 
        placeholder={placeholder} 
        onChange={e => onSearch(e.target.value)} 
      />
      <button className={buttonClasses}>
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
      </button>
    </div>
  );
}
